module.exports = __webpack_public_path__ + "img/Essenza Cofani - Mappa.f210885a.png";